import { TrendingUp, TrendingDown, AlertCircle } from "lucide-react";

const AIExecutiveSummary = () => {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex justify-between items-start">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-1">
              AI Executive Summary
              </h1>
              <p className="text-sm text-gray-600">
              Generated: Today • Audience: Collector, Smart City CEO, Festival Commissioner
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-border mb-8"></div>

        {/* Metrics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {/* Total Pilgrims Card */}
          <div className="bg-card rounded-lg shadow-sm border border-border p-6">
            <div className="text-secondary text-sm font-medium mb-2">
              Total Pilgrims (Live)
            </div>
            <div className="flex items-center gap-2 mb-2">
              <span className="text-4xl font-bold text-foreground">7.2 lakh</span>
              <TrendingUp className="w-6 h-6 text-success" />
            </div>
            <div className="text-sm text-secondary">+8% vs last weekend</div>
          </div>

          {/* Average Queue Time Card */}
          <div className="bg-card rounded-lg shadow-sm border border-border p-6">
            <div className="text-secondary text-sm font-medium mb-2">
              Average Queue Time
            </div>
            <div className="flex items-center gap-2 mb-2">
              <span className="text-4xl font-bold text-foreground">18 mins</span>
              <TrendingDown className="w-6 h-6 text-accent" />
            </div>
            <div className="text-sm text-secondary">↓ 5 mins post redirection</div>
          </div>

          {/* Water Complaints Card */}
          <div className="bg-card rounded-lg shadow-sm border border-border p-6">
            <div className="text-secondary text-sm font-medium mb-2">
              Water Complaints
            </div>
            <div className="mb-2">
              <span className="text-4xl font-bold text-foreground">12% of total</span>
            </div>
            <div className="text-sm text-secondary">Mostly near Toilet A/B</div>
          </div>

          {/* Cleanliness Feedback Card */}
          <div className="bg-card rounded-lg shadow-sm border border-border p-6">
            <div className="text-secondary text-sm font-medium mb-2">
              Cleanliness Feedback
            </div>
            <div className="flex items-center gap-2 mb-2">
              <span className="text-4xl font-bold text-foreground">72% positive</span>
              <TrendingUp className="w-6 h-6 text-success" />
            </div>
            <div className="text-sm text-secondary">Improving trend</div>
          </div>

          {/* Peak Density Card */}
          <div className="bg-card rounded-lg shadow-sm border border-border p-6">
            <div className="text-secondary text-sm font-medium mb-2">
              Peak Density
            </div>
            <div className="mb-2">
              <span className="text-4xl font-bold text-foreground">45k @ Ram Ghat</span>
            </div>
            <div className="text-sm text-secondary">Predicted to fall in 20 mins</div>
          </div>

          {/* System Health Card */}
          <div className="bg-card rounded-lg shadow-sm border border-border p-6">
            <div className="text-secondary text-sm font-medium mb-2">
              System Health
            </div>
            <div className="mb-2">
              <span className="text-4xl font-bold text-foreground">99.9% uptime</span>
            </div>
            <div className="text-sm text-secondary">Stable</div>
          </div>
        </div>

        {/* AI Summary Section */}
        <div className="bg-card rounded-lg shadow-sm border border-border p-6 mb-6">
          <div className="flex items-center gap-2 mb-4">
            <span className="inline-flex items-center justify-center w-8 h-8 rounded bg-accent text-accent-foreground text-sm font-bold">
              AI
            </span>
            <h2 className="text-xl font-bold text-foreground">AI Summary</h2>
          </div>
          <ul className="space-y-3">
            <li className="flex gap-3">
              <span className="text-foreground mt-1">•</span>
              <span className="text-foreground">
                Overall crowd flow is stable across major ghats.
              </span>
            </li>
            <li className="flex gap-3">
              <span className="text-foreground mt-1">•</span>
              <span className="text-foreground">
                Water and cleanliness remain top recurring issues.
              </span>
            </li>
            <li className="flex gap-3">
              <span className="text-foreground mt-1">•</span>
              <span className="text-foreground">
                Predictive congestion detected near Bhandara sector; action required within 20 mins.
              </span>
            </li>
          </ul>
        </div>

        {/* Action Required Alert */}
        <div className="bg-warning-light border-2 border-warning rounded-lg p-4 mb-8">
          <div className="flex items-start gap-3">
            <AlertCircle className="w-5 h-5 text-warning-foreground flex-shrink-0 mt-0.5" />
            <div>
              <div className="font-semibold text-warning-foreground mb-1">
                Action Required:
              </div>
              <div className="text-warning-foreground">
                Predictive congestion detected near Bhandara sector within 20 minutes.
              </div>
            </div>
          </div>
        </div>

        {/* Footer Legend */}
        <div className="border-t border-border pt-4">
          <div className="text-sm text-secondary space-y-1">
            <div>
              <span className="font-medium">Legend:</span> ↑ increase • ↓ decrease • Live metrics from QR/feedback/sensors
            </div>
            <div className="text-secondary">
              Shipra Admin • AI + AR + QR Navigation Intelligence
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIExecutiveSummary;

